// extracted by mini-css-extract-plugin
module.exports = {"transactionFlagComment":"FlagComments_transactionFlagComment__2ePac","transactionFlagCommentListItem":"FlagComments_transactionFlagCommentListItem__aoiaE"};